// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_2jNAb","avatarImage":"_1vv4e","profileName":"B9kqa","reply":"t-1xl","postPage":"_2cJkC","user":"_1xqeV","profileInfo":"_1uKCP"};